export const container = 'px-6';
export const iconContainer = 'my-5';
export const headerContainer = 'mb-5';
export const headerTitle = 'font-bold';
export const headerSubTitle = 'text-xs';
export const subText = 'text-xs';
export const selectInputLabel="text-sm font-semibold"
